export enum LoaderSize {
    S = "s",
    M = 'm',
    L = 'l',
}